import React from "react";

/**
 * ITER-246: Legacy Features chip list on the car ad detail page.
 * Renders `attributes.Features` — an array of 0..46 legacy option
 * strings (ABS brakes … Wireless Phone Charging). Backwards-compatible
 * with older listings that saved Features as a comma-separated string.
 */
export default function CarFeaturesChips({ listing }) {
  const raw = listing?.attributes?.Features;
  let items = [];
  if (Array.isArray(raw)) items = raw.filter(Boolean);
  else if (typeof raw === "string" && raw.trim()) {
    items = raw
      .split(/,|\s·\s|\r?\n|;/)
      .map((s) => s.trim())
      .filter(Boolean);
  }
  if (!items.length) return null;
  return (
    <div
      data-testid="ad-car-features"
      className="mt-4 rounded-2xl bg-white border border-soft p-5"
    >
      <h2 className="font-display text-lg font-bold text-slate-800">Features</h2>
      <ul className="mt-3 flex flex-wrap gap-2">
        {items.map((f) => (
          <li
            key={f}
            data-testid={`feature-chip-${String(f)
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "-")
              .replace(/^-|-$/g, "")}`}
            className="rounded-full bg-[color:var(--brand-blue-wash)] text-[color:var(--brand-blue)] px-3 py-1 text-xs font-semibold border border-[color:var(--brand-blue-wash)]"
          >
            {f}
          </li>
        ))}
      </ul>
    </div>
  );
}
